<template>
  <div>
    <ElRow type="flex" justify="center">
      <div class="login-form">
        <div v-if="sendEmail" style="text-align: center">
          <SuccessButton></SuccessButton>
          <ElRow type="flex" justify="center" style="margin: -5px 0px 20px 0px">
            <ElCol :span="24" class="text-center">
              <span class="text-center success-message">
                <br />
                {{ $t('success') }}
                <br />
                <br />
                {{ $t('send_email') }}
              </span>
            </ElCol>
          </ElRow>
        </div>

        <div v-else>
          <ElRow type="flex" justify="center">
            <ElCol class="login-title">{{ $t('recovery_password') }}</ElCol>
          </ElRow>
          <Transition name="el-fade-in">
            <ElRow style="margin: 0 0 0 0" v-show="fail">
              <ElCol type="flex" justify="center" style="margin: 0 0 -5px 0">
                <p class="fail-login">{{ $t('server_validation_failure') }}</p>
              </ElCol>
            </ElRow>
          </Transition>
          <ElRow style="margin-bottom: 0px">
            <ElForm
              :model="form"
              :rules="rules"
              ref="form"
              style="margin: 15px 0 0 0"
              @submit.native.prevent
              @keydown.native.enter="submitForm('form')"
            >
              <ElFormItem prop="email">
                <ElInput id="email" v-model="form.email" placeholder="Email" />
              </ElFormItem>
              <ElFormItem style="margin-bottom: 0px">
                <ElRow type="flex" justify="center" style="margin-bottom: 15px">
                  <ElCol :span="24">
                    <ElButton
                      id="reset"
                      type="primary"
                      class="enter-button"
                      :loading="loading"
                      style="width: 100%"
                      @click="submitForm('form')"
                      >{{ $t('reset_password') }}</ElButton
                    >

                    <VueRecaptcha
                      v-if="globalRecaptcha.enabled && globalRecaptcha.key"
                      ref="invisibleRecaptcha"
                      size="invisible"
                      loadRecaptchaScript
                      :sitekey="globalRecaptcha.key"
                      @verify="resetPassword"
                      @expired="submitForm"
                    />
                  </ElCol>
                </ElRow>
              </ElFormItem>
            </ElForm>
          </ElRow>
        </div>
        <ElRow type="flex" justify="center">
          <ElCol class="text-center form-footer-text-block">
            {{ $t('return_to_login') }}
            <RouterLink to="/login">{{ $t('sign_in') }}</RouterLink>
          </ElCol>
        </ElRow>
      </div>
    </ElRow>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import SuccessButton from '../components/Success.vue';

export default {
  components: { VueRecaptcha, SuccessButton },
  i18n: {
    messages: {
      ru: {
        success: 'Поздравляем!',
        sign_in: 'страницу Входa',
        reset_password: 'Сбросить пароль',
        recovery_password: 'Восстановление пароля',
        return_to_login: 'Вернуться на ',
        send_email:
          'Мы отправили вам письмо с инструкциями по сбросу пароля. Если вы не получили подтверждающее сообщение в течение нескольких минут, проверьте папку со спамом или нежелательной почтой.',
      },
      uk: {
        success: 'Вітаємо!',
        sign_in: 'сторінку Входу',
        reset_password: 'Скинути пароль',
        recovery_password: 'Відновлення пароля',
        return_to_login: 'Повернутися на ',
        send_email:
          'Ми надіслали вам електронний лист із інструкціями щодо зміни пароля. Якщо Ви не отримаєте повідомлення про підтвердження протягом декількох хвилин, перевірте спам або папку небажаної пошти.',
      },
      en: {
        success: 'Success!',
        sign_in: 'Login page',
        reset_password: 'Reset password',
        recovery_password: 'Password recovery',
        return_to_login: 'Return to the ',
        send_email:
          'We have sent you an email with reset instructions. If you do not receive the confirmation message within a few minutes, please check spam or junk email folder.',
      },
    },
  },
  data() {
    return {
      sendEmail: false,
      loading: false,
      fail: false,
      form: {
        email: '',
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t('validation_email_require'),
            trigger: 'blur',
          },
          {
            type: 'email',
            required: true,
            message: this.$t('validation_email'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.fail = false;

          if (this.globalRecaptcha.enabled) {
            this.$refs.invisibleRecaptcha.execute();
          } else {
            this.resetPassword(null);
          }
        }
      });
    },
    resetPassword(reCaptchaKey) {
      const dataForm = {
        ...this.form,
        'g-recaptcha-response': reCaptchaKey || null,
      };

      this.$http.post('/resetting', dataForm).then(
        response => {
          const data = response.data;

          this.loading = false;
          this.sendEmail = true;
        },
        error => {
          this.fail = true;
          const response = error.response.data;
          this.loading = false;
        }
      );

      if (this.$refs.invisibleRecaptcha !== undefined) {
        this.$refs.invisibleRecaptcha.reset();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fail-login {
  color: #ff4949;
  font-size: 14px;
  text-align: center;
}

.login-form {
  margin: 0 auto;
  width: 273px;
  background: white;
  padding: 30px 60px 15px 60px;
  color: #424c61;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);

  @media screen and (max-width: 500px) {
    padding: 15px 30px 15px 30px;
  }
}

.login-title {
  text-align: center;
  font-size: 22px;
  margin-bottom: -5px;
}

.ElRow {
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
}

.ElCol {
  border-radius: 4px;
}

.text-center {
  text-align: center;
}

.success-message {
  line-height: 1.6em;
}
</style>
